import dynamic from 'next/dynamic';
import { PlannerLoginProps } from './PlannerLogin.types';

export const PlannerLogin = dynamic<{ model: PlannerLoginProps }>(() =>
  import('./PlannerLogin').then(mod => mod.PlannerLogin)
);
